<template>
  <div>
    <section class="personal-center" ref="brokerCenter">
      <div class="desktop-broker-info mobile-broker-info" style="">
          <span style="font-size: 18px;">{{userName}}<br></span>
          <span>{{fullName}}<br></span>
          <span>{{phoneNumber}}<br></span>
          <span>{{email}}<br></span>
      </div>
      <span class="sidebarbutton">
        <nav
          id="navbar"
          class="navbar navbar-expand-md navbar-light"
          style="font-color:#0082BA;font-size: 16px; font-weight: bold; max-width: 200px; margin: 0;"
        >
          <button
            class="toggler-icon btn btn-info"
            type="button"
            data-toggle="collapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="toggleSidebar"
          >
            <span class="navbar-toggler-icon"></span> Action Menu
            <i class="fa fa-sort-desc fa-2x" aria-hidden="true"></i>
          </button>
        </nav>
      </span>

      <div class="wrapper">
        <nav id="sidebar" :class="{active}">
          <div class="userimg lightbluebg" style="background: #2ecc71;padding: 18px 0 18px 16px;">
            <!-- <img src="./Bitmap2.jpg"> -->
            <img :src="userImg" intrinsicsize="52 x 52" />
            <span class="p-3">{{employer.name}}</span>
          </div>
          <ul class="personal-center__nav-list">
            <router-link
              @click.native="setActive"
              to="/brokerCenter/myApplication/applicationList"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan', $route.meta.name === 'myApplication' ? 'active' : '']"
            >MY APPLICATIONS</router-link>
            <li
              @click="startApply"
              class="personal-center__nav-list-item--my-loan"
            >NEW APPLICATION</li>
            <!-- <router-link
              @click.native="setActive"
              to="/brokerCenter/profile"
              tag="li"
              :class="['personal-center__nav-list-item--business', $route.meta.name === 'BusinessInfo' ? 'active' : '']"
            >BUSINESS INFO</router-link> -->
            <router-link
              to="/brokerCenter/updatePassword"
              tag="li"
              class="personal-center__nav-list-item--update-password"
            >RESET PASSWORD</router-link>
            <li @click="logout" class="personal-center__nav-list-item--my-info">LOG OUT</li>
          </ul>
        </nav>
        <router-view class="broker-center__router-view"></router-view>
      </div>
    </section>
    <div class="row">
      <div class="col-lg-2 col-sm-0 p-3"></div>
        <div class="col-lg-5 col-sm-8 p-3">
          <el-dialog title="notice" :visible.sync="centerDialogVisible" center>
            <span>Are you sure you want to log out?</span>
            <span slot="footer" >
              <el-button @click="centerDialogVisible = false">Cancel</el-button>
              <el-button type="primary" @click="confirmLogout">OK</el-button>
            </span>
          </el-dialog>
        </div>
      <div class="col-lg-2 col-sm-1 p-3"></div>
    </div>

    <el-dialog
      class="broker-contract-dialog"
      top="5%"
      :visible.sync="showAgreementDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleDialogClose"
    >
      <span slot="title"><img
              :src="require('../assets/imgs/American Credit_logo_TM_a.png')"
              class="img-fluid logo"
              alt="American Credit Logo"
            /></span>
      <div v-if="showSignDeclarationWarning"><h4 style="color:red; text-align: center;">Please sign declaration file first.</h4></div>
      <div class="contract__dialog-body agreement_contract declaration__dialog-body">
        <img :src="readContract" alt="read" />
      </div>
      <div slot="footer" class="dialog__footer">
        <el-button
          v-if="signBtn.isShow"
          class="dialog__footer__confirm-btn sign_btn"
          :disabled="signBtn.state"
          @click="showSignAgreement"
          style="margin-right:30px;"
        >{{signBtn.text}}</el-button>
        <el-button
          v-if="!signBtn.isShow"
          class="dialog__footer__confirm-btn sign_btn"
          :disabled="signBtn.state"
          @click="hideAgreement"
          style="margin-right:30px;"
        >Continue</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="showSignDialog"
      title="Please type in full name to sign the declaration digitally"
      :visible.sync="showSignDialog"
    >
      <el-form>
        <el-form-item>
          <el-input
            placeholder="Please input full name to sign"
            v-model="fullName"
            auto-complete="off"
            @change="allowSubmit"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSignDialog = false">Cancel</el-button>
        <el-button type="primary" @click="signAgreement" :disabled="allowSubmitBut">Sign</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="showSignDialog"
      title="Please select which loan you would like to apply"
      :visible.sync="showSelectLoanDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form>
        <el-form-item>
          <el-select v-model="loan" v-on:change="onLoanChange" placeholder="Select loan to apply" class="select_loan_width">
            <el-option
              v-for="item in loanS"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSelectLoanDialog = false">Cancel</el-button>
        <el-button type="primary" @click="continueApply" :disabled="allowApplyBut">Apply</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import * as types from "../vuex/types";
import api from "../vuex/api/index";

export default {
  data() {
    return {
      phoneNumber: "",
      email: "",
      active: "",
      screenHeight: document.body.clientHeight,
      userImg: "",
      userName: "",
      centerDialogVisible: false,
      declarationId: 10000058500118,
      showSignDeclarationWarning: false,
      showAgreementDialog: false,
      showSignDialog: false,
      fullName: "",
      allowSubmitBut: true,
      signBtn: {
        state: false,
        text: "Sign Declaration",
        isShow: true
      },
      showSelectLoanDialog: false,
      allowApplyBut: true,
      loan: "",
      loanS: [
        { value: "Equipment Finance", text: "Equipment Finance" },
        { value: "Working Capital Term Loan", text: "Working Capital Term Loan" },
        { value: "Commercial Real Estate", text: "Commercial Real Estate" },
        { value: "2nd Mortgage Loan", text: "2nd Mortgage Loan" }
      ],
      employer: {
        name: ""
      },
      linkYourBankLink: `/applyLoan/${localStorage.getItem("$applyId")}/sbl2`,
      updateApplicationLink: `/applyLoan/${localStorage.getItem("$applyId")}/update`
    };
  },
  computed: {
    ...mapGetters({
      companyInfo: types.GET_COMPANY_INFO,
      userInfo: types.GET_USER,
      products: types.GET_HOT_PRODUCTS,
      readDeclaration: types.GET_DECLARATION_IMAGE_SRC
    }),
    readContract() {
      return `${this.readDeclaration}01&loanItemContractId=${this.declarationId}`;
    }
  },
  mounted() {
    this.getPersonalInitData({
      token: this.userInfo.token
    })
    .then(res => {
      console.log(res);
      // no need to show dec file to broker any more
      // if (Number(res.data.code) === 0) {
      //   const data = res.data.result;
      //   if(data.declarationId == null || data.declarationId == 10000058500118) {
      //     this.showAgreementDialog = true;
      //   } else {
      //     this.declarationId = data.declarationId;
      //   }
      // }
      this.userImg = res.data.result.customerPhoto
        ? "/mingdao/platform/system/sysFile/getFileById.ht?fileId=" +
          res.data.result.customerPhoto
        : require("../assets/imgs/user.png");
      this.userName = res.data.result.customerName;
      if(res.data.result.middleName && res.data.result.middleName != '' && res.data.result.middleName != 'null') {
        this.fullName = res.data.result.firstName + ' ' + res.data.result.middleName + ' ' + res.data.result.lastName;
      } else {
        this.fullName = res.data.result.firstName + ' ' + res.data.result.lastName;
      }

      this.phoneNumber = res.data.result.phone;
      this.email = res.data.result.email;
      
      this.employer = {
        name: res.data.result.employer.name
      };

    })
    .catch(err => {
      console.log("getPersonalInitData error");
    });
  },
  methods: {
    ...mapMutations({
      //      companyInfo: types.GET_COMPANY_INFO,
      setActiveName: types.SET_ACTIVE_NAME,
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE
    }),
    ...mapActions({
      updatePassword: types.UPDATE_PASSWORD,
      getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA,
      userLogout: types.USER_LOGOUT,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),

    allowSubmit(val) {
      if (this.fullName != "") {
        this.allowSubmitBut = false;
      } else {
        this.allowSubmitBut = true;
      }
    },

    onLoanChange() {
      if (this.loan != "") {
        this.allowApplyBut = false;
      } else {
        this.allowApplyBut = true;
      }
    },

    continueApply() {
      if(this.loan === "Equipment Finance") {
        this.$router.push(`/apply`);
      }
      if(this.loan === "Working Capital Term Loan") {
        this.$router.push(`/apply-term-loan`);
      }
      if(this.loan === "Commercial Real Estate") {
        this.$router.push(`/apply-real-estate`);
      }
      if(this.loan === "2nd Mortgage Loan") {
        this.$router.push(`/apply-2nd-mortgage`);
      }
    },

    startApply() {
      this.showSelectLoanDialog = true;
    },

    showAgreement() {
      this.showAgreementDialog = true;
    },

    hideAgreement() {
      this.showAgreementDialog = false;
    },

    showSignAgreement() {
      this.showSignDialog = true;
    },

    signAgreement() {
      const _this = this;
      var fullName = this.fullName;
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyConfirmSignDeclaration.ht",
          {
            tokenId: this.userInfo.token,
            contractId: 10000058500118,
            fullName: fullName
          }
        )
        .then(res => {
          const data = res.data;
          if (data.code === 0) {
            _this.setSuccessModal({
              show: true,
              content: data.msg
            });
            this.showSignDialog = false;
            this.declarationId = data.result;
            this.signBtn.isShow = false;
            this.signBtn.state = false;
            this.signBtn.text = "Signed";
            this.showSignDeclarationWarning = false;
          } else if (data.code === 1) {
            this.setFailModal({
              show: true,
              content: data.msg
            });
          }
        });
    },
    downAgreement2() {
      window.open(
        `/mingdao/mobile/item/pdfSignatureController/readDeclaration.ht?download=true&fileType=PDF&identify=01&loanItemContractId=${this.declarationId}`
      );
    },

    setActive() {
      this.setActiveName("2");
      this.closeSidebar();
    },
    logout() {
      this.closeSidebar();
      this.centerDialogVisible = true;
    },
    confirmLogout() {
      this.centerDialogVisible = false;
      this.userLogout({
        router: this.$router
      });
    },
    gotoApply() {
      this.closeSidebar();
      this.$router.push(`/applyLoan/10000058380010/sbl`);
    },
    showSidebar() {
      this.active = "";
    },
    toggleSidebar() {
      if (this.active == "active") {
        this.active = "";
      } else {
        this.active = "active";
      }
    },
    closeSidebar() {
      this.active = "";
    },
    handleDialogClose(done) {
      if(this.declarationId == null || this.declarationId == 10000058500118) {
        this.showSignDeclarationWarning = true;
      } else {
        done();
      }
    }
  }
};
</script>


<style scoped lang="scss">
@import "../assets/css/style.css";

.desktop-broker-info {
  float: right; 
  padding-right: 10%; 
  padding-bottom: 20px; 
  font-size: 14px; 
  line-height: 16px; 
  color: blue;
}

@media (max-width: 768px) {
  .mobile-broker-info {
    padding-top: 10px;
    width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.logo {
  display: block;
  width: 13vw;
  min-width: 14em;
  max-width: 250px;
  background: rgba(255, 255, 255, 0.1);
  padding: 5px;
  border-radius: 8%;
}

.personal-center-container {
  margin-bottom: 40px;
  .userimg {
    background: #2ecc71;
    width: 100%;
    box-sizing: border-box;
    padding: 18px 0 18px 16px;
    img {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      display: inline-block;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      vertical-align: middle;
      margin-left: 10px;
      font-size: 14px;
    }
  }
}

@mixin personalCenterNavLi {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-family: "FZLanTingHei-DB-GBK";

  &:before {
    content: "";
    display: inline-block;
    margin: 0 10px 0 10px;
    vertical-align: -8px;
    width: 28px;
    height: 28px;
  }

  &.active {
    background: #243342;
  }
}

.personal-center-container {
  background: #f5f7f8;
}

.personal-center {
  @include clear;
  position: relative;
  margin: 20px auto;
  /*min-height: 648px;*/
  background: #ffffff;
  max-width: 1440px;
}

.personal-center__nav {
  margin-top: 20px;
  @include clear;
  float: left;
  position: absolute;
  width: 250px;
  height: 96%;
  color: $white;
  background: #34495e;
}

.personal-center__nav-list {
  padding: 20px 0;
  li:hover {
    cursor: pointer;
  }
}

.personal-center__nav-list-item--my-loan {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_money.png") no-repeat;
  }
}

.personal-center__nav-list-item--business {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_id_card.png") no-repeat;
  }
}

.personal-center__nav-list-item--my-info {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_user.png") no-repeat;
  }
}

.personal-center__nav-list-item--bankcard-info {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_bankcard.png") no-repeat;
  }
}

.personal-center__nav-list-item--file-uploading {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_upload.png") no-repeat;
  }
}

.personal-center__nav-list-item--real-name-auth {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_id_card.png") no-repeat;
  }
}

.personal-center__nav-list-item--update-password {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_gear.png") no-repeat;
  }
}

.broker-center__router-view {
  height: 100%;
  min-height:600px;
}
</style>

<style lang="scss">
.broker-contract-dialog {
  .el-dialog__header .el-dialog__headerbtn {
    top: 20% !important;
  }
}
</style>



// WEBPACK FOOTER //
// BrokerCenter.vue?01c6e3a3